var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaperPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.001,
    height: 22,
    viewBox: "0 0 22.001 22",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.587 7.501l-2.943-2.944a1.416 1.416 0 00-2 0l-12.5 12.5v4.94h4.94l12.5-12.5a1.416 1.416 0 000-2zM8.344 20.215H5.93v-2.414l8.428-8.429 2.415 2.414zm9.693-9.692l-2.414-2.414 2.024-2.024 2.414 2.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.135 12.445h1.786v-6.25h2.678V4.41H4.457v1.786h2.678z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.357 16.071H1.786V1.786h14.285v3.571h1.786V1.786A1.786 1.786 0 0016.071 0H1.786A1.786 1.786 0 000 1.786v14.285a1.786 1.786 0 001.786 1.786h3.571z"
  })));
}

export default SvgIconPaperPen;